import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAuditLogs } from '../lib/auditApi';

const auditQueryKey = (filters) => ['audit-logs', filters];

export const useAuditLogs = () => {
  const [filters, setFilters] = useState({
    entityType: '',
    actorType: '',
    actionType: '',
    dateFrom: '',
    dateTo: '',
    limit: 200,
    offset: 0,
  });

  const query = useQuery({
    queryKey: auditQueryKey(filters),
    queryFn: () => fetchAuditLogs(filters),
    refetchInterval: 15000,
  });

  const rows = useMemo(() => query.data?.items || [], [query.data]);

  return {
    filters,
    setFilters,
    rows,
    total: Number(query.data?.total || 0),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
